import React from 'react'
import SideQSub from './SideQSubT'
import '../../Questions.css'

export default function TenthBiology() {
    return (
        <>
            <SideQSub />
            <div className="q-banner"></div>

            <div className="pdf-container">


                <div className="pdf-content">

                    <h1 className="pdf-title">Chapter Wise PDFs</h1>
                    <ol>
                        <li className="pdf-list">
                            <div className='float-l'>Ch-6 Life Processes</div>
                            <a target='_blank' href="https://examautomation-my.sharepoint.com/personal/jagrati_mukati_brisklearning_com/_layouts/15/onedrive.aspx?ga=1&id=%2Fpersonal%2Fjagrati%5Fmukati%5Fbrisklearning%5Fcom%2FDocuments%2F2%2E%20Product%20Delivery%2F13%2D05%2D2023%2FNotes%20With%20Mind%20Map%20Abhishek%20Shrivastava%20%288619082008%29%2F1%2E%20PDF%2FClass%2010th%2FScience%2FBiology%2FChapter%20%2D%206%20Life%5FProcesses%2Epdf&parent=%2Fpersonal%2Fjagrati%5Fmukati%5Fbrisklearning%5Fcom%2FDocuments%2F2%2E%20Product%20Delivery%2F13%2D05%2D2023%2FNotes%20With%20Mind%20Map%20Abhishek%20Shrivastava%20%288619082008%29%2F1%2E%20PDF%2FClass%2010th%2FScience%2FBiology">
                                <span className="float-r"><button type="button" class="btn">
                                    <strong>VIEW</strong>
                                    <div id="container-stars">
                                        <div id="stars"></div>
                                    </div>

                                    <div id="glow">
                                        <div class="circle"></div>
                                        <div class="circle"></div>
                                    </div></button>
                                </span>
                            </a>
                        </li>
                        <hr />
                        <li className="pdf-list"> <div className='float-l'>Ch-7 Control and Coordination</div>
                            <a target='_blank' href="https://examautomation-my.sharepoint.com/personal/jagrati_mukati_brisklearning_com/_layouts/15/onedrive.aspx?ga=1&id=%2Fpersonal%2Fjagrati%5Fmukati%5Fbrisklearning%5Fcom%2FDocuments%2F2%2E%20Product%20Delivery%2F13%2D05%2D2023%2FNotes%20With%20Mind%20Map%20Abhishek%20Shrivastava%20%288619082008%29%2F1%2E%20PDF%2FClass%2010th%2FScience%2FBiology%2FChapter%20%2D%207%20Control%5Fand%5FCoordination%2Epdf&parent=%2Fpersonal%2Fjagrati%5Fmukati%5Fbrisklearning%5Fcom%2FDocuments%2F2%2E%20Product%20Delivery%2F13%2D05%2D2023%2FNotes%20With%20Mind%20Map%20Abhishek%20Shrivastava%20%288619082008%29%2F1%2E%20PDF%2FClass%2010th%2FScience%2FBiology"> <span className="float-r"><button type="button" class="btn">
                                <strong>VIEW</strong>
                                <div id="container-stars">
                                    <div id="stars"></div>
                                </div>

                                <div id="glow">
                                    <div class="circle"></div>
                                    <div class="circle"></div>
                                </div></button>
                            </span></a>
                        </li>
                        <hr />
                        <li className="pdf-list"> <div className='float-l'>Ch-8 How Do Organisms Reproduce</div>
                            <a target='_blank' href="https://examautomation-my.sharepoint.com/personal/jagrati_mukati_brisklearning_com/_layouts/15/onedrive.aspx?ga=1&id=%2Fpersonal%2Fjagrati%5Fmukati%5Fbrisklearning%5Fcom%2FDocuments%2F2%2E%20Product%20Delivery%2F13%2D05%2D2023%2FNotes%20With%20Mind%20Map%20Abhishek%20Shrivastava%20%288619082008%29%2F1%2E%20PDF%2FClass%2010th%2FScience%2FBiology%2FChapter%20%2D%208%20How%5FDo%5FOrganisms%5FReproduce%2Epdf&parent=%2Fpersonal%2Fjagrati%5Fmukati%5Fbrisklearning%5Fcom%2FDocuments%2F2%2E%20Product%20Delivery%2F13%2D05%2D2023%2FNotes%20With%20Mind%20Map%20Abhishek%20Shrivastava%20%288619082008%29%2F1%2E%20PDF%2FClass%2010th%2FScience%2FBiology"> <span className="float-r"><button type="button" class="btn">
                                <strong>VIEW</strong>
                                <div id="container-stars">
                                    <div id="stars"></div>
                                </div>

                                <div id="glow">
                                    <div class="circle"></div>
                                    <div class="circle"></div>
                                </div></button>
                            </span></a>
                        </li>
                        <hr />
                        <li className="pdf-list"> <div className='float-l'>Ch-9 Hereditary and Evolution</div>
                            <a target='_blank' href="https://examautomation-my.sharepoint.com/personal/jagrati_mukati_brisklearning_com/_layouts/15/onedrive.aspx?ga=1&id=%2Fpersonal%2Fjagrati%5Fmukati%5Fbrisklearning%5Fcom%2FDocuments%2F2%2E%20Product%20Delivery%2F13%2D05%2D2023%2FNotes%20With%20Mind%20Map%20Abhishek%20Shrivastava%20%288619082008%29%2F1%2E%20PDF%2FClass%2010th%2FScience%2FBiology%2FChapter%20%2D%209%20Heredity%5Fand%5FEvolution%2Epdf&parent=%2Fpersonal%2Fjagrati%5Fmukati%5Fbrisklearning%5Fcom%2FDocuments%2F2%2E%20Product%20Delivery%2F13%2D05%2D2023%2FNotes%20With%20Mind%20Map%20Abhishek%20Shrivastava%20%288619082008%29%2F1%2E%20PDF%2FClass%2010th%2FScience%2FBiology"> <span className="float-r"><button type="button" class="btn">
                                <strong>VIEW</strong>
                                <div id="container-stars">
                                    <div id="stars"></div>
                                </div>

                                <div id="glow">
                                    <div class="circle"></div>
                                    <div class="circle"></div>
                                </div></button>
                            </span></a>
                        </li>
                        <hr />
                        <li className="pdf-list"> <div className='float-l'>Ch-15 Our Enviornment</div>

                            <a target='_blank' href="https://examautomation-my.sharepoint.com/personal/jagrati_mukati_brisklearning_com/_layouts/15/onedrive.aspx?ga=1&id=%2Fpersonal%2Fjagrati%5Fmukati%5Fbrisklearning%5Fcom%2FDocuments%2F2%2E%20Product%20Delivery%2F13%2D05%2D2023%2FNotes%20With%20Mind%20Map%20Abhishek%20Shrivastava%20%288619082008%29%2F1%2E%20PDF%2FClass%2010th%2FScience%2FBiology%2FChapter%20%2D%2015%20Our%20Environment%2Epdf&parent=%2Fpersonal%2Fjagrati%5Fmukati%5Fbrisklearning%5Fcom%2FDocuments%2F2%2E%20Product%20Delivery%2F13%2D05%2D2023%2FNotes%20With%20Mind%20Map%20Abhishek%20Shrivastava%20%288619082008%29%2F1%2E%20PDF%2FClass%2010th%2FScience%2FBiology"> <span className="float-r"><button type="button" class="btn">
                                <strong>VIEW</strong>
                                <div id="container-stars">
                                    <div id="stars"></div>
                                </div>

                                <div id="glow">
                                    <div class="circle"></div>
                                    <div class="circle"></div>
                                </div></button>
                            </span></a>
                        </li>
                        <li className="pdf-list"> <div className='float-l'>Ch-16 Management of Natural Resources</div>

                            <a target='_blank' href="https://examautomation-my.sharepoint.com/personal/jagrati_mukati_brisklearning_com/_layouts/15/onedrive.aspx?ga=1&id=%2Fpersonal%2Fjagrati%5Fmukati%5Fbrisklearning%5Fcom%2FDocuments%2F2%2E%20Product%20Delivery%2F13%2D05%2D2023%2FNotes%20With%20Mind%20Map%20Abhishek%20Shrivastava%20%288619082008%29%2F1%2E%20PDF%2FClass%2010th%2FScience%2FBiology%2FChapter%20%2D%2016%20Management%5Fof%5FNatural%5FResources%20New%2Epdf&parent=%2Fpersonal%2Fjagrati%5Fmukati%5Fbrisklearning%5Fcom%2FDocuments%2F2%2E%20Product%20Delivery%2F13%2D05%2D2023%2FNotes%20With%20Mind%20Map%20Abhishek%20Shrivastava%20%288619082008%29%2F1%2E%20PDF%2FClass%2010th%2FScience%2FBiology"> <span className="float-r"><button type="button" class="btn">
                                <strong>VIEW</strong>
                                <div id="container-stars">
                                    <div id="stars"></div>
                                </div>

                                <div id="glow">
                                    <div class="circle"></div>
                                    <div class="circle"></div>
                                </div></button>
                            </span></a>
                        </li>
                        <hr />
                    </ol>
                </div>





            </div>
        </>

    )
}
